const BookReaders = ({ book, readers, currentUser, onUserClick }) => {
  return (
    <>
      <div className="section-label" style={{marginTop:"1rem"}}>이 책을 읽은 독자들</div>
      <div className="readers-list">
        {readers.map((r, i) => {
          const isMe = r.id === currentUser?.uid;
          return (
            <div
              key={r.id}
              className={`reader-item${isMe ? " reader-me" : ""}`}
              style={{ animationDelay: `${i * 0.08}s`, cursor: isMe ? "default" : "pointer" }}
              onClick={() => !isMe && onUserClick(r.id)}
            >
              <div className="reader-avatar">{r.avatar}</div>
              <div style={{ flex: 1 }}>
                <div className="reader-name">{r.name}{isMe ? " (나)" : ""}</div>
                <div className="reader-date">
                  {book.completedBy && book.completedBy[r.id]
                    ? `${book.completedBy[r.id]} 독서완료`
                    : "읽는 중..."}
                </div>
              </div>
              {!isMe && (
                <div>
                  <div className="similarity-bar"><div className="similarity-fill" style={{ width: `${r.similarity}%` }} /></div>
                  <div className="similarity-label">취향 {r.similarity}%</div>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </>
  );
};

export default BookReaders;
